export enum MODAL_VARIANTS {
  center = 'center',
  fullSize = 'fullSize',
  extraWide = 'extraWide',
  right = 'right',
}
